import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-big-calendar';
import moment from 'moment';
import { useAuth } from 'hooks';
import TimeGrid from 'react-big-calendar/lib/TimeGrid';
import { useScheduleCalendar } from 'hooks/scheduleCalendar';

function WeekView(props) {
  const { token } = useAuth();
  const { currentDate } = useScheduleCalendar(token);
  const range = WeekView.range(currentDate);
  return <TimeGrid {...props} date={moment(currentDate).toDate()} range={range} eventOffset={15} />;
}

WeekView.range = (date) => {
  const count = 7;
  const range = [];

  const start = moment(date).startOf('week');

  for (let i = 0; i < count; i++) {
    range.push(moment(start).add(i, 'days').toDate());
  }
  return range;
};

WeekView.navigate = (date, action) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return moment(date).subtract(5, 'days').toDate();
    case Navigate.NEXT:
      return moment(date).add(5, 'days').toDate();
    default:
      return moment(date).toDate();
  }
};

WeekView.title = (date) => {
  return `${moment(date).format('DD MMM')} - ${moment(date).add(5, 'days').format('DD MMM')}`;
};

export default WeekView;
